module.exports = __webpack_public_path__ + "static/media/pay_papara.c485519d.svg";